

import {Options, Vue} from "vue-class-component";
import {ThemeTreeNode} from '@/entities/ThemeTree';
import {PropType} from 'vue';
import {isDefined} from '@/utils';
import {Theme} from '@/entities/Theme';

@Options({
  components: {ThemeDisplay},
  props: {
    nodes: {
      default: undefined,
      required: true,
      type: Array as PropType<Array<ThemeTreeNode>>
    },
    themes: {
      default: [],
      required: true,
      type: Array as PropType<Array<Theme>>
    },
    entityThemes: {
      default: [],
      required: true,
      type: Array as PropType<Array<String>>
    }
  }
})
export default class ThemeDisplay extends Vue {

  private themes: Theme[];
  private entityThemes: String[];

  constructor(props) {
    super(props);
  }

  public isSelectedTheme(node: ThemeTreeNode): boolean {
    return this.entityThemes.findIndex(id => id === node.theme.id) > -1;

  }

  public hasDirectSelectedLeaf(nodes: ThemeTreeNode[]): boolean {
    for (const node of nodes) {
      if (this.entityThemes.findIndex(id => id === node.theme.id) > -1) {
        return true;
      }
    }
    return false;
  }

  public hasSelectedInThemes(nodes: ThemeTreeNode[]): boolean {
    for (const node of nodes) {
      if (this.entityThemes.findIndex(id => id === node.theme.id) > -1) {
        return true;
      }
      if (node.children.length > 0) {
        if (this.hasSelectedInThemes(node.children)) {
          return true;
        }
      }
    }
    return false;
  }

  public getThemeById(id): Theme {
    return this.themes.find(v => v.id === id);
  }

  public getBreadCrumbForTheme(theme: Theme): string {
    let breadCrumb = '';
    if (isDefined(theme)) {
      breadCrumb = theme.title;
      if (theme.parentId !== 'ROOT') {
        theme = this.getThemeById(theme.parentId);
        while (theme !== undefined && theme.parentId !== 'ROOT') {
          breadCrumb = `${theme.title} >> ${breadCrumb}`;
          theme = this.getThemeById(theme.parentId);
        }
      }
    }
    return breadCrumb;
  }


}
